import { ConfigurationModel, UserModel } from '@anecdotes/commenting';

export abstract class AbstractCommentingUiConfigurationProvider {
  abstract getConfiguration(): ConfigurationModel;

  abstract getCurrentUserAsync(): Promise<UserModel>;

  abstract sendUserEvent(eventType: string, eventData: any): void;
}
